<template>
  <div v-if="loading" class="square-20">
    <Spinner />
  </div>
  <div v-else class="address" :class="{'address--truncated': truncated }">
    <span v-if="errorMessage" class="text-danger">{{ errorMessage }}</span>
    <span v-else-if="!address">-</span>
    <template v-else>
      <span v-html="address" />
      <a :href="`${googleMapUrl(lat, lng)}`" class="eye" target="_blank">
        <i class="icon-eye" />
      </a>
    </template>
  </div>
</template>
<script setup>
import {onBeforeUnmount, ref, watch} from "vue";
import {useStore} from "vuex";
import Spinner from "@/js/Elements/Spinner.vue";
import {googleMapUrl} from "@/js/helpers.js";

const store = useStore();
const props = defineProps({
  lat: [String, Number],
  lng: [String, Number],
  truncated: Boolean
});
const loading = ref(true);
const address = ref(null);
let watcher = null;
const errorMessage = ref(null);

onBeforeUnmount(() => {
  if (!watcher) return;
  watcher();
});

load();

function load() {
  address.value = null;

  if (watcher) {
    watcher();
  }

  if (!props.lat || !props.lng) {
    loading.value = false;
    setupWatcher();
    return;
  }

  loading.value = true;
  errorMessage.value = null;
  store.dispatch('address/load', {
    hash: store.getters['object/hash'],
    lat: props.lat,
    lng: props.lng
  }).catch((message) => {
    errorMessage.value = message;
  }).then((response) => {
    address.value = response;
  }).finally(() => {
    setupWatcher();
    loading.value = false;
  });
}

function setupWatcher() {
  watcher = watch(() => [props.lat, props.lng], load);
}
</script>
<style lang="scss" scoped>
@import "@/css/functions";
@import "@/css/variables";

.address--truncated {
  display: flex;
  overflow: hidden;
  width: 100%;

  > span {
    display: inline-block;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.eye {
  border: themeColor('border') solid toRem(1);
  border-radius: $border-radius;
  padding: 0 toRem(2) toRem(2) toRem(2);
  margin-left: spacing(1);
  text-decoration: none;

  > i {
    color: themeColor('text');
  }
}
</style>